import React, {Component} from 'react';

class DefaultLayout extends Component {
    render () {
        return <div>{ this.props.children }</div>;
    }
}

export default DefaultLayout;


// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/index.js